import { useMemo } from "react";
import { Link, useSearchParams } from "wouter";
import { AlertCircle } from "lucide-react";
import { PageNavigation } from "../components/ui/page-navigation";
import PowerBIReportEmbed from "../components/powerbi/PowerBIReportEmbed";

const VBCDashboard = () => {
  const [searchParams] = useSearchParams();
  const appointmentId = (searchParams.get("appointmentId") || "").trim();
  const patientName = (
    searchParams.get("patientName") ||
    searchParams.get("patient") ||
    ""
  ).trim();
  const date = (searchParams.get("date") || "").trim();
  const selectedMetricKey = (searchParams.get("metric") || "").trim().toLowerCase();
  const doctorEmail = (searchParams.get("doctorEmail") || "").trim();
  const doctorId = (searchParams.get("doctorId") || "").trim();
  const clinicId = (searchParams.get("clinicId") || "").trim();

  const hasAnyScope = useMemo(
    () =>
      Boolean(
        appointmentId ||
        patientName ||
        selectedMetricKey ||
        date ||
        doctorEmail ||
        doctorId ||
        clinicId
      ),
    [appointmentId, patientName, selectedMetricKey, date, doctorEmail, doctorId, clinicId]
  );

  return (
    <div className="px-4 pb-6">
      <div className="max-w-6xl mx-auto space-y-6">
        <PageNavigation
          title="Visit Details"
          subtitle="Power BI dashboard"
          showBackButton={true}
          rightSlot={
            <Link
              href="/vbc"
              className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
              Back to Summary
            </Link>
          }
        />

        {!hasAnyScope && (
          <div className="animate-in fade-in duration-300 rounded-xl border border-gray-200 bg-white p-8 shadow-sm">
            <div className="flex flex-col items-center text-center">
              <div className="mb-4 rounded-full bg-amber-100 p-3">
                <AlertCircle className="h-8 w-8 text-amber-600" />
              </div>

              <h2 className="text-xl font-semibold text-gray-900">
                No Visit Selected
              </h2>

              <p className="mt-2 max-w-lg text-sm leading-6 text-gray-600">
                You navigated directly to the VBC Dashboard without selecting a visit.
                Please return to the VBC Summary page and choose a visit to view the
                Power BI dashboard.
              </p>

              <Link
                href="/vbc"
                className="mt-6 inline-flex items-center rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white transition-colors duration-200 hover:bg-blue-700"
              >
                Go to VBC Summary
              </Link>
            </div>
          </div>
        )}

        {hasAnyScope && (
          <PowerBIReportEmbed
            appointmentId={appointmentId}
            patientName={patientName}
            date={date}
            metric={selectedMetricKey}
            doctorEmail={doctorEmail}
            doctorId={doctorId}
            clinicId={clinicId}
          />
        )}
      </div>
    </div>
  );
};

export default VBCDashboard;
